import {makeAutoObservable, observable} from 'mobx'
import {createUseStore} from '@containers/hooks'
import {FileViewData} from '@extensions/message-utils'

interface State {
  selectedFilesToView: FileViewData[]
  selectedFileToViewIndex: number
  chatPinModified: number
  descriptionScroll: number
  subtasksScroll: number
}

export class RightPanelContentStore {
  state: State = {
    selectedFilesToView: [],
    selectedFileToViewIndex: -1,
    chatPinModified: 0,
    descriptionScroll: -1,
    subtasksScroll: -1
  }

  constructor() {
    makeAutoObservable(this, {
      state: observable.shallow
    })
  }

  setSelectedFilesToView(
    selectedFilesToView: FileViewData[],
    fileIndex: number
  ): void {
    this.state.selectedFilesToView = selectedFilesToView
    this.state.selectedFileToViewIndex = fileIndex
  }

  updateChatPin(): void {
    this.state.chatPinModified = Date.now()
  }

  closeFileViewer(): void {
    this.state.selectedFilesToView = []
  }

  setDescriptionScroll(value: number): void {
    this.state.descriptionScroll = value
  }
  setSubtasksScroll(value: number): void {
    this.state.subtasksScroll = value
  }
}

export const [RightPanelContentContext, useRightPanelContentStore] =
  createUseStore(RightPanelContentStore)
